module.exports = __webpack_public_path__ + "img/saveSVG.1999de9a.svg";